/*
  TASK-4988 — Отложенная доставка: order checker on /pages/delayed-delivery.

  TASK-4994 changed EXACTLY ONE thing in this file: the FAQ accordion is now
  single-open. TASK-4995 changed nothing at all.

  TASK-4996 changed the IDENTITY PAIR. The form used to ask for the email plus
  the EXACT total that was paid; it now asks for the ORDER NUMBER plus the email
  on that same order, and posts them to the ils-admin backend
  (POST /api/delayed-shipping/lookup). The total was a bad shared secret on a
  multi-currency store — it is ambiguous once an order settles in PLN/SEK/HUF
  and it moves after a refund — while the order number is printed on the
  confirmation email and never changes. Everything else in this file is
  untouched on purpose: the neutral-miss message, the server-side lock mirror,
  the opaque client token, the success rendering and the single-open accordion
  all behave exactly as before.

  The Shopify Admin API is NEVER touched from the browser: this file has no
  token, no shop credential and no order list. All the backend ever returns is
  the DELAYED line items of the one order that matched both fields.

  Rate limiting is SERVER-side (Postgres, 5 failures → 1 hour, see
  db_delayed_lookup.js). The localStorage mirror below exists only so the
  locked state survives a reload and the user is not made to wait on a request
  that is going to be refused anyway — clearing localStorage does NOT unlock
  anything, the server re-imposes the lock on the very next attempt.

  The clientToken is an opaque random value with no personal data in it. The
  server stores only a salted SHA-256 of it, so a stolen database row cannot be
  traced back to a browser.

  TASK-5003 — this file no longer contains a single customer-facing string.
  All of them are custom.delayed.* keys whose English source lives in
  locales/en.default.json and whose DE / LV / LT / ET translations and five
  INDEPENDENT Russian market targets are published by the production ILS
  Translator. Liquid resolves them for the active locale/market and hands them
  over as one JSON blob on the section root (data-i18n); this file only reads
  that blob. The one exception is the Latin literal "SKU" (TASK-4998), which is
  language-invariant in every locale this page can render in.

  The EN-dash rule (TASK-4996 §2: «–» U+2013, never «—» U+2014) now lives with
  the copy, i.e. in the translator (global rule 3), not in here.

  TASK-5488 — TENSE. The backend (ils-admin delayed_shipping_routes.js) now
  answers the HISTORICAL question "did THIS order contain a delayed line when it
  was placed?", so an order whose promised date has already arrived reports its
  delayed lines again instead of showing the empty state. Every string on this
  page was written in the future tense, which would now be actively misleading
  about a parcel that has already shipped — so each item carries
  state: 'pending' | 'past' and the summary is chosen by data.anyPending.
  A line also carries certainty: 'confirmed' | 'unconfirmed'; 'unconfirmed'
  means the product's metafields were edited after they were created, so the
  order-time value cannot be proven, and the line is shown WITH a caveat rather
  than printed as a fact or quietly dropped. Each new key falls back to the
  present-tense key of the SAME locale — never to another locale's literal —
  so a market whose translation is not registered yet degrades to the old
  wording instead of to an empty line.
*/
(function () {
  'use strict';

  var TOKEN_KEY = 'ILS_DS_TOKEN_V1';
  var LOCK_KEY = 'ILS_DS_LOCK_V1';

  // TASK-4996 — the one place the order-number length lives. I Love Snacks
  // order numbers are 5 digits today (#16403). If the counter ever rolls over,
  // change this constant and the helper text in the section's Liquid; the
  // BACKEND is already tolerant (3-8 digits) and needs no change.
  var ORDER_NO_DIGITS = 5;

  // TASK-5003 — the whole message set, read off the section root. There is
  // deliberately NO hardcoded fallback copy: a key that failed to resolve must
  // render empty, never as a Russian or English literal leaking into another
  // locale. The neutral-miss contract is unchanged — "generic" is still the
  // ONE message every kind of miss produces (wrong order number, wrong email,
  // wrong pair, malformed value), so the three of them stay indistinguishable.
  function readI18n(root) {
    try { return JSON.parse(root.getAttribute('data-i18n') || '{}') || {}; }
    catch (e) { return {}; }
  }

  // "Paid: {value}" + "8,99 €" -> "Paid: 8,99 €". An unknown placeholder is
  // left verbatim rather than blanked, so a bad translation is visible in QA
  // instead of silently eating the number.
  function fill(tpl, map) {
    return String(tpl == null ? '' : tpl).replace(/\{([a-z]+)\}/g, function (whole, k) {
      return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : whole;
    });
  }

  // 1 минуту / 2 минуты / 5 минут, 1 minute / 5 minutes, pēc 1 minūtes /
  // pēc 5 minūtēm … The plural CATEGORY comes from the browser's own CLDR data
  // for the page locale, so no language's grammar is hardcoded here any more:
  // Latvian needs 'zero', Lithuanian needs 'few', Russian needs 'few'+'many',
  // German/Estonian/English only ever use 'one'/'other'. All five categories
  // are separate translator keys (custom.delayed.js_minutes_*).
  function pluralCategory(locale, n) {
    try { return new Intl.PluralRules(locale || 'en').select(n); } catch (e) { return 'other'; }
  }

  function lockedText(i18n, locale, minutes) {
    var m = Math.max(1, Math.min(60, minutes || 60));
    var unit = i18n['minutes_' + pluralCategory(locale, m)] || i18n.minutes_other || '';
    return fill(i18n.locked, { minutes: String(m), unit: unit });
  }

  function store(key, value) {
    try { window.localStorage.setItem(key, value); } catch (e) {}
  }
  function read(key) {
    try { return window.localStorage.getItem(key); } catch (e) { return null; }
  }

  function clientToken() {
    var t = read(TOKEN_KEY);
    if (t && /^[A-Za-z0-9_-]{16,64}$/.test(t)) return t;
    var bytes = new Uint8Array(16);
    if (window.crypto && window.crypto.getRandomValues) {
      window.crypto.getRandomValues(bytes);
    } else {
      for (var i = 0; i < bytes.length; i++) bytes[i] = Math.floor(Math.random() * 256);
    }
    var hex = '';
    for (var j = 0; j < bytes.length; j++) hex += ('0' + bytes[j].toString(16)).slice(-2);
    store(TOKEN_KEY, hex);
    return hex;
  }

  function lockRemainingMinutes() {
    var until = parseInt(read(LOCK_KEY) || '0', 10);
    if (!until || !isFinite(until)) return 0;
    var left = until - Date.now();
    if (left <= 0) return 0;
    return Math.ceil(left / 60000);
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* TASK-4996 — the order-number field is DIGITS ONLY, enforced as you type.
     Everything else is dropped, which is what makes "no # required or allowed"
     true even for a paste of "#16403" or of a tracking code: the letters simply
     never land in the value. Truncating to ORDER_NO_DIGITS here (not only in
     the submit check) is deliberate — it makes the maxlength attribute
     redundant rather than the only guard, and it stops a paste of a 20-digit
     parcel number silently sitting in a field that looks full. */
  function sanitizeOrderNumber(raw) {
    return String(raw == null ? '' : raw).replace(/\D+/g, '').slice(0, ORDER_NO_DIGITS);
  }

  function looksLikeEmail(s) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(s || '').trim());
  }
  function looksLikeOrderNumber(s) {
    return new RegExp('^\\d{' + ORDER_NO_DIGITS + '}$').test(String(s || '').trim());
  }

  function init(root) {
    if (!root || root.__ilsDsReady) return;
    root.__ilsDsReady = true;

    var endpoint = root.getAttribute('data-endpoint') || '';
    var i18n = readI18n(root);
    // Shopify's iso_code for the request (en / de / lv / lt / et / ru). Used
    // for the CLDR plural category and sent to the backend so the order lines
    // come back with the product title and weight unit of THIS locale.
    var locale = root.getAttribute('data-locale') || document.documentElement.lang || 'en';
    var form = root.querySelector('[data-ds-form]');
    var orderEl = root.querySelector('[data-ds-order]');
    var emailEl = root.querySelector('[data-ds-email]');
    var submitEl = root.querySelector('[data-ds-submit]');
    var statusEl = root.querySelector('[data-ds-status]');
    var resultsEl = root.querySelector('[data-ds-results]');
    if (!form || !orderEl || !emailEl || !submitEl || !statusEl || !resultsEl) return;

    var submitLabel = submitEl.textContent;

    function setStatus(text, kind) {
      statusEl.className = 'ils-ds__status' + (kind ? ' ils-ds__status--' + kind : '');
      statusEl.textContent = text || '';
    }

    function clearResults() {
      resultsEl.innerHTML = '';
      resultsEl.hidden = true;
    }

    function setBusy(busy) {
      submitEl.disabled = busy;
      orderEl.disabled = busy;
      emailEl.disabled = busy;
      submitEl.textContent = busy ? (i18n.checking || submitLabel) : submitLabel;
      submitEl.setAttribute('aria-busy', busy ? 'true' : 'false');
    }

    function applyLock(minutes) {
      store(LOCK_KEY, String(Date.now() + Math.max(1, minutes) * 60000));
      showLocked(minutes);
    }

    function showLocked(minutes) {
      clearResults();
      setStatus('', null);
      resultsEl.hidden = false;
      resultsEl.innerHTML = '<div class="ils-ds__locked">' + escapeHtml(lockedText(i18n, locale, minutes)) + '</div>';
      setBusy(false);
      submitEl.disabled = true;
    }

    function renderSuccess(data) {
      var items = (data && data.items) || [];
      var html = '';
      if (!items.length) {
        html = '<div class="ils-ds__empty">' + escapeHtml(i18n.empty) + '</div>';
      } else {
        html += '<h3 class="ils-ds__h2">' + escapeHtml(i18n.results_title) + '</h3>';
        for (var i = 0; i < items.length; i++) {
          var it = items[i];
          var meta = [];
          // TASK-4998 — the label stays the Latin "SKU" in every locale this
          // page can render in. Do not localise it to Артикул / Artikuls /
          // Artikelnummer / SKU-kood; the mock-up card in the section Liquid
          // already prints "SKU: …" and the two must read the same.
          if (it.sku) meta.push('SKU: ' + it.sku);
          if (it.variant) meta.push(fill(i18n.weight, { value: it.variant }));
          meta.push(fill(i18n.qty, { value: String(it.quantity || 0) }));
          // TASK-5488 — 'past' once the promised date has arrived or the order
          // has shipped / been cancelled. Falls back to the present-tense key
          // of the SAME locale, so an unregistered translation degrades to the
          // old wording rather than to an empty line.
          var expectedTpl = (it.state === 'past' && i18n.expected_past) || i18n.expected;
          html +=
            '<div class="ils-ds__item">' +
            (it.image
              ? '<img class="ils-ds__item-img" src="' + escapeHtml(it.image) +
                '" alt="" width="88" height="88" loading="lazy" decoding="async">'
              : '<span class="ils-ds__item-img" aria-hidden="true"></span>') +
            '<div class="ils-ds__item-body">' +
            '<p class="ils-ds__item-name">' + escapeHtml(it.title) + '</p>' +
            '<p class="ils-ds__item-meta">' + escapeHtml(meta.join(' · ')) + '</p>' +
            // The TEMPLATE is escaped first and the value is substituted after,
            // so the <b> wrapper survives while the data itself stays escaped.
            //
            // TASK-5488 — a line recovered from the snapshot of a product that
            // has since been deleted has no paid figure, and "Paid:" with
            // nothing after it reads like a bug, so the line is dropped whole.
            (it.paidText
              ? '<p class="ils-ds__item-paid">' +
                fill(escapeHtml(i18n.paid), { value: '<b>' + escapeHtml(it.paidText) + '</b>' }) + '</p>'
              : '') +
            '<p class="ils-ds__item-date">' +
            fill(escapeHtml(expectedTpl), { value: '<b>' + escapeHtml(it.dateText) + '</b>' }) + '</p>' +
            // TASK-5488 — the honesty marker. Only rendered when the backend
            // could not prove the order-time state AND the locale has the key.
            (it.certainty === 'unconfirmed' && i18n.unconfirmed
              ? '<p class="ils-ds__item-note">' + escapeHtml(i18n.unconfirmed) + '</p>'
              : '') +
            '</div></div>';
        }
        if (data.latestDateText) {
          // TASK-5488 — the future tense is used ONLY while something is
          // genuinely still pending. anyPending === false is the backend's
          // explicit signal; a backend (or a cached response) that does not send
          // the field at all leaves it undefined, which keeps the pre-TASK-5488
          // wording — the strictly safer default.
          var summaryTpl = (data.anyPending === false && i18n.summary_past) || i18n.summary;
          html +=
            '<div class="ils-ds__summary">' +
            fill(escapeHtml(summaryTpl), { value: '<b>' + escapeHtml(data.latestDateText) + '</b>' }) +
            '</div>';
        }
      }
      resultsEl.innerHTML = html;
      resultsEl.hidden = false;
      setStatus('', null);
    }

    // --- initial state: a lock recorded earlier still applies -------------
    var pending = lockRemainingMinutes();
    if (pending > 0) showLocked(pending);

    orderEl.addEventListener('input', function () {
      var before = orderEl.value;
      var after = sanitizeOrderNumber(before);
      if (after !== before) {
        var pos = orderEl.selectionStart;
        orderEl.value = after;
        try { orderEl.setSelectionRange(pos - (before.length - after.length), pos - (before.length - after.length)); } catch (e) {}
      }
      orderEl.removeAttribute('aria-invalid');
    });
    emailEl.addEventListener('input', function () { emailEl.removeAttribute('aria-invalid'); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var stillLocked = lockRemainingMinutes();
      if (stillLocked > 0) { showLocked(stillLocked); return; }

      // Re-sanitise on submit as well: autofill and drag-and-drop can put a
      // value into the field without ever firing `input`.
      orderEl.value = sanitizeOrderNumber(orderEl.value);
      var orderNumber = orderEl.value;
      var email = emailEl.value.trim();

      // Client-side validation shows the SAME neutral message the server uses,
      // so a bad format never tells the visitor which field was the problem.
      var orderOk = looksLikeOrderNumber(orderNumber);
      var emailOk = looksLikeEmail(email);
      if (!orderOk || !emailOk) {
        if (!orderOk) orderEl.setAttribute('aria-invalid', 'true');
        if (!emailOk) emailEl.setAttribute('aria-invalid', 'true');
        clearResults();
        setStatus(i18n.generic, 'error');
        (orderOk ? emailEl : orderEl).focus();
        return;
      }

      if (!endpoint) { setStatus(i18n.unavailable, 'error'); return; }

      clearResults();
      setBusy(true);
      setStatus(i18n.checking, 'muted');

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'omit',
        // TASK-5003 — `locale` is DISPLAY-ONLY: the backend uses it to pick the
        // product title translation and the weight unit it renders. It takes no
        // part in identifying the order, so it cannot widen the lookup or the
        // anti-enumeration surface in any way.
        body: JSON.stringify({ orderNumber: orderNumber, email: email, locale: locale, clientToken: clientToken() }),
      })
        .then(function (r) {
          return r.json().then(function (j) { return { status: r.status, body: j || {} }; });
        })
        .then(function (res) {
          setBusy(false);
          var b = res.body;
          if (res.status === 429 || b.error === 'locked') {
            applyLock(b.retryAfterMinutes || 60);
            return;
          }
          if (b.ok === true) {
            store(LOCK_KEY, '0');
            renderSuccess(b);
            return;
          }
          if (b.error === 'not_found') { setStatus(i18n.generic, 'error'); return; }
          setStatus(i18n.unavailable, 'error');
        })
        .catch(function () {
          setBusy(false);
          setStatus(i18n.unavailable, 'error');
        });
    });

    // --- FAQ accordion — SINGLE-OPEN (TASK-4994) --------------------------
    // At most one answer is visible: opening an item closes whichever was open.
    // The loop walks only THIS section's own buttons (root.querySelectorAll),
    // so a second [data-ils-ds] root could never close the other one's panels.
    // `hidden` on the panel is the single source of truth for the state and
    // aria-expanded is kept in step with it for assistive tech.
    var questions = root.querySelectorAll('[data-ds-q]');

    function closeQuestion(btn) {
      btn.setAttribute('aria-expanded', 'false');
      var p = document.getElementById(btn.getAttribute('aria-controls'));
      if (p) p.hidden = true;
    }

    for (var q = 0; q < questions.length; q++) {
      questions[q].addEventListener('click', function () {
        var wasOpen = this.getAttribute('aria-expanded') === 'true';
        for (var k = 0; k < questions.length; k++) {
          if (questions[k] !== this) closeQuestion(questions[k]);
        }
        // Re-clicking the open item still collapses it, so the section can
        // legitimately end up with nothing open.
        this.setAttribute('aria-expanded', wasOpen ? 'false' : 'true');
        var panel = document.getElementById(this.getAttribute('aria-controls'));
        if (panel) panel.hidden = wasOpen;
      });
    }
  }

  function boot() {
    var roots = document.querySelectorAll('[data-ils-ds]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Section re-render in the theme editor.
  document.addEventListener('shopify:section:load', boot);
})();
